import IInfoPages from ".//IInfoPages";
import SystemConfig, {CONFIG_PARAMS} from "../system/SystemConfig";
import events from "../events/EventsObservable";
import {ACTION_EVENTS} from "../ui/UserAction";
import {injectable} from "inversify";
import SystemPlatform from "../system/SystemPlatform";
import {EVENTS} from "../events/baseEvents";
import {GAME_EVENTS} from "../game/gameEvents";
import {WALLET_EVENTS} from "../wallet/Wallet";
import {BASE_ELEMENT_IDS} from "../ui/BaseDOM";

@injectable()
export default abstract class AbstractInfoPages implements IInfoPages {

    protected config: SystemConfig;
    protected platform: SystemPlatform;

    protected isHided: boolean;

    protected constructor(config: SystemConfig) {
        this.config = config;
        this.platform = config.platform;

        events.subscribe(ACTION_EVENTS.ACTION_INFO_TOGGLE, (eventName, data) => this.toggle(data));
        events.subscribe(ACTION_EVENTS.ACTION_INFO_ARROW, (eventName, data) => this.arrow(data));
        events.subscribe(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_RIGHT, (eventName, data) => this.arrow("left"));
        events.subscribe(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_LEFT, (eventName, data) => this.arrow("right"));

        events.subscribe(GAME_EVENTS.GAME_START_ROUND, (eventName, data) => this.onStartRound());
        events.subscribe(WALLET_EVENTS.WALLET_ON_SET_BET, (eventName, data) => this.onBetChange());
        events.subscribe(WALLET_EVENTS.WALLET_ON_SET_LINES_COUNT, (eventName, data) => this.onBetChange());
        events.subscribe(EVENTS.INFO_CLOSE_REQUEST, (eventName, data) => this.close())
    }

    create() {
        if(this.platform.isVLT() && this.platform.getDisplaysCount() === 2) {
            this.isHided = true;
            this.open();
        } else {
            this.isHided = false;
            this.close();
        }
    };

    isOpen(): boolean {
        return !this.isHided;
    }

    async open(): Promise<boolean> {
        if(!this.isHided) return false;

        await events.dispatch(EVENTS.INFO_ON_OPEN);

        if(this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES)) {

            this.showWintable();

            if(!this.platform.isVLT() || (this.platform.isVLT() && this.platform.getDisplaysCount() == 1)) {
                this.hideGame();
            }
        }

        this.isHided = false;

        return true;
    }

    async close(): Promise<boolean> {

        if(this.isHided || (this.platform.isVLT() && this.platform.getDisplaysCount() == 2)) {
            return false;
        }

        this.hideWintable();
        this.showGame();

        await events.dispatch(EVENTS.INFO_ON_CLOSE);

        this.isHided = true;

        return true;
    }

    async toggle(data: any) {
        return this.isOpen() ? this.close() : this.open()
    }

    abstract onRoundStart();

    abstract onBetChange();

    abstract next();

    abstract prev();

    abstract home();

    async arrow(data: any): Promise<boolean> {

        if(this.isHided) return;

        if(data === "home") {
            return this.home();
        }

        if(data === "left") {
            return this.prev()
        }

        return this.next()
    }

    showWintable() {
        $("#" + BASE_ELEMENT_IDS.WINTABLE_WRAPPER).show();
    };

    hideWintable() {
        $("#" + BASE_ELEMENT_IDS.WINTABLE_WRAPPER).hide();
    };

    showGame() {
        $("#" + BASE_ELEMENT_IDS.GAME_WRAPPER).show();
    };
    hideGame() {
        $("#" + BASE_ELEMENT_IDS.GAME_WRAPPER).hide();
    };

    onStartRound() {
        if(this.platform.isVLT() && this.platform.getDisplaysCount() == 2) {
            this.home();
        }
    }
}
